import { render, staticRenderFns } from "./ValueOrNA.vue?vue&type=template&id=2b0c4200&"
import script from "./ValueOrNA.vue?vue&type=script&lang=ts&"
export * from "./ValueOrNA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports